import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Show } from "../components/Show";

type StepDetail = {
  title: string;
  shortTitle?: string;
  description?: string;
};

export type StepperProps = {
  steps: StepDetail[];
  index: number;
};

export const useStepper = (props: StepperProps) => {
  const { steps, index } = props;
  const { activeStep, setActiveStep } = useSteps({
    index,
    count: steps.length,
  });

  const isMobile = useBreakpointValue({ base: true, md: false });

  const stepper = (
    <Stepper
      index={activeStep}
      colorScheme="blue"
      size={{ base: "sm", md: "md" }}
      orientation="horizontal"
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box flexShrink="0" fontSize={{ base: "2xs", md: "sm" }}>
            <StepTitle>{isMobile && step.shortTitle ? step.shortTitle : step.title}</StepTitle>
            <Show when={!!step.description && !isMobile}>
              <StepDescription>{step.description}</StepDescription>
            </Show>
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );

  return { stepper, setActiveStep, activeStep };
};
